import { connect } from 'react-redux'
import RepositorySelect from './RepositorySelect'

const mapStateToProps = (state, props) => {
  var repo = state.repositories[props.id]
  return {
    name: repo.name
  }
}

export default connect(mapStateToProps)(RepositorySelect)


// WEBPACK FOOTER //
// ./src/modules/RepositorySelect/Container.js